import { T, useIsDesktop } from '../reportTokens';

// Stamp KPI tile for the offer drilldowns. Geometry mirrors the Snapshot
// drill-in's mini KPI (`.snapshot-mini-k` / `.rpt-card--r12`) so a KPI card
// reads the same in every report drilldown: a white card with a border and
// the card shadow — not the grey inset box this used to be. Mobile keeps the
// same card, only trimming the padding / value size so three tiles still fit
// a phone row.
export function MiniKPI({ label, value }: { label: string; value: React.ReactNode }) {
    const isDesktop = useIsDesktop();
    return (
        <div style={{
            flex: '1 1 100px',
            minWidth: 100,
            background: T.card,
            border: `1px solid ${T.cardBorder}`,
            boxShadow: T.shadow,
            borderRadius: 12,
            padding: isDesktop ? '14px 16px' : '12px 14px',
        }}>
            <div style={{ fontSize: 10, fontWeight: 500, color: T.t3, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: isDesktop ? 20 : 18, fontWeight: 700, letterSpacing: -0.5, color: T.t1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div>
        </div>
    );
}

// Body wrapper for a drilldown page. The header (back button + parent › title)
// lives in the shared top bar — driven by the report screen — matching the other
// report screens; this component only owns the page padding.
export default function DrillFrame({ isDesktop, children }: {
    isDesktop: boolean;
    children: React.ReactNode;
}) {
    return (
        <div style={{ padding: isDesktop ? 24 : 0, fontFamily: T.font, color: T.t1 }}>
            {children}
        </div>
    );
}
